import React from 'react';

import { FacilitiesListPage } from '../../shared/facilities/FacilitiesListPage';

const STAFF_FACILITIES_LIST_QUERY_KEY = 'staffFacilitiesList';

export const StaffFacilitiesList: React.FC = () => {
  return (
    <FacilitiesListPage
      title="Facilities"
      queryKeyBase={STAFF_FACILITIES_LIST_QUERY_KEY}
      displayTypePrefKey="StaffFacilities"
      showOrganization={true}
      showOrganizationFilter={true}
    />
  );
};
